import API from "../index";
import {API_GET_SEARCH_INSPECTION_HISTORY_RESULT} from "../../constants/api";

async function getInspectionHistoryResult(params = {}) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    const data = { ...params };
    const response = await API.get(
      API_GET_SEARCH_INSPECTION_HISTORY_RESULT,
      { params: data },
      { headers }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
}

export { getInspectionHistoryResult };